import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import useAttribute from "./useAttribute";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const { reset, handleSubmit, setErrors, setData, attributeFields } = useAttribute();
  const { id, attributeId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('attributes/' + attributeId, {params: {category_id : id}}).then(res => {
      reset(res.data.attribute);
    });
  }, []);

  const editAttribute = data => {
    data.category_id = id;

    axios.put('attributes/' + attributeId, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Attributes has been updated successfully!', {
            icon: "success",
          });
          navigate(-1);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit attribute">
      <form className="form w-100 row" onSubmit={handleSubmit(editAttribute)}>
        {attributeFields}
        <SubmitButton
          title="Update"
          classes="w-auto d-inline-block"
        />
      </form>
    </Card>
  );
}